const guideMargin = '1vw'

const styles = {
  guide: {
    marginTop: guideMargin,
    '&:first-child': {
      marginTop: '0'
    }
  }
}

export { styles, guideMargin }
